import { getDomainFromHost } from '../utils/getDomain';
import { domainConfig } from '../config/domainConfig';

let cachedConfig;
let cachedHostname;

export function getDomainConfig() {
  const currentHostname = typeof window !== "undefined" ? window.location.hostname : "";

  if (cachedConfig && cachedHostname === currentHostname) {
    return cachedConfig;
  }

  cachedHostname = currentHostname;
  const domain = getDomainFromHost();
  cachedConfig = domainConfig[domain] || domainConfig["us"];

  return cachedConfig;
}
